import { api } from "./api";

export const addTeamApi = (params) => {
    return api.post(`/team/create`, JSON.stringify(params));
};

export const teamListApi = (params) => {
    return api.get(`/team/list`, { params });
};

export const userDropdownApi = (params) => {
    return api.get(`/team/users-list`, { params });
};

export const teamLeadDropdownApi = (params) => {
    return api.get(`/team/tl-list`, { params });
};

export const editTeamApi = (params) => {
    return api.post(`/team/edit`, JSON.stringify(params));
};

export const deleteTeamApi = (params) => {
    return api.post(`/team/delete`, JSON.stringify(params));
};

export const viewTeamApi = (params) => {
    return api.get(`/team/view`, { params });
};

export const deleteTeamUserApi = (params) => {
    return api.post(`/team/delete-user`, JSON.stringify(params));
};

export const addTeamUserApi = (params) => {
    return api.post(`/team/add-user`, JSON.stringify(params));
};
